import * as Yup from 'yup';

export const APPROVE_PARTICIPANT_VALIDATION_SCHEMA = Yup.object().shape({
  approvalComment: Yup.string().defined().max(250, 'Превышено максимальное число символов'),
});
